function ensureKlaviyoReviewsWidget() {
  var widget = document.getElementById('klaviyo-reviews-all');
  if (!widget) return;

  var productId = widget.getAttribute('data-id') || widget.getAttribute('data-product-id');
  if (productId) {
    widget.setAttribute('data-id', productId);
    widget.setAttribute('data-product-id', productId);
  }

  function tryRender() {
    try {
      if (window.klReviewsObject && typeof window.klReviewsObject.renderWidgets === 'function') {
        window.klReviewsObject.renderWidgets();
      }
    } catch (e) {}
  }

  tryRender();
  [120, 500, 1200, 2400].forEach(function(delay) {
    setTimeout(tryRender, delay);
  });

  setTimeout(function() {
    if (widget.childElementCount > 0) return;
    if (document.querySelector('script[data-pdp-klaviyo-reviews-refresh]')) return;
    var source = document.querySelector('script[src*="static.klaviyo.com/onsite/js"][src*="klaviyo.js"][src*="company_id"]');
    if (!source || !source.src) return;
    var refresh = document.createElement('script');
    refresh.async = true;
    refresh.src = source.src + (source.src.indexOf('?') === -1 ? '?' : '&') + 'pdp_reviews_refresh=' + Date.now();
    refresh.setAttribute('data-pdp-klaviyo-reviews-refresh', 'true');
    refresh.onload = function() {
      [80, 450, 1000].forEach(function(delay) {
        setTimeout(tryRender, delay);
      });
    };
    document.head.appendChild(refresh);
  }, 900);
}

// Clicking the top star-widget opens the Reviews accordion.
// Simulates a click on the summary so the theme's CollapsibleElements custom
// element handles the open animation + height measurement correctly.
function openReviewsAccordion() {
  var accordion = document.querySelector('details.accordion.review, .accordion.review');
  if (accordion) {
    var summary = accordion.querySelector('summary[data-collapsible-trigger], summary');
    if (!accordion.hasAttribute('open')) {
      if (summary) summary.click();
      else accordion.setAttribute('open', 'true');
    }
    setTimeout(function(){
      var body = accordion.querySelector('[data-collapsible-body]');
      if (body) body.style.height = 'auto';
      ensureKlaviyoReviewsWidget();
      accordion.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 60);
    return;
  }
  // Fallback: no accordion on this template → scroll directly to the
  // Klaviyo reviews list or the review widget section.
  var target = document.querySelector('#klaviyo-reviews-list, .kl_reviews__reviews_list, [id*="klaviyo_reviews"]');
  if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

document.addEventListener('click', function(e) {
  var widget = e.target.closest(
    '.kl_reviews__star_rating_widget, .klaviyo-star-rating-widget, [data-clone-review-widget], .pdp-sticky-bar__reviews'
  );
  if (!widget) return;
  if (e.target.closest('.accordion.review')) return;
  e.preventDefault();
  e.stopPropagation();
  openReviewsAccordion();
}, true);
document.addEventListener('touchend', function(e) {
  var widget = e.target.closest(
    '.kl_reviews__star_rating_widget, .klaviyo-star-rating-widget, [data-clone-review-widget], .pdp-sticky-bar__reviews'
  );
  if (!widget) return;
  if (e.target.closest('.accordion.review')) return;
  openReviewsAccordion();
}, { passive: true });

// Single-open accordions inside the product page: opening one closes others.
// Scoped to PDP accordions so it doesn't break FAQ / global accordion groups.
document.addEventListener('click', function(e){
  var trigger = e.target.closest('.product-accordion [data-collapsible-trigger], .product__block--accordion [data-collapsible-trigger], .accordion [data-collapsible-trigger]');
  if (!trigger) return;
  var current = trigger.closest('details');
  if (!current) return;
  // Only act inside the main product column (avoid FAQ section etc.)
  var productCol = current.closest('.product__wrapper, [data-product], .product__page, .form__width');
  if (!productCol) return;
  // Close sibling accordions in the same product column.
  setTimeout(function(){
    if (current.matches('details.accordion.review, .accordion.review')) {
      ensureKlaviyoReviewsWidget();
    }
    var all = productCol.querySelectorAll('details.accordion, details');
    all.forEach(function(d){
      if (d !== current && d.hasAttribute('open')) {
        var body = d.querySelector('[data-collapsible-body]');
        if (body) { body.style.height = ''; }
        d.removeAttribute('open');
      }
    });
  }, 0);
}, true);

// Hide reviews UI ONLY when Klaviyo positively reports zero reviews.
// Default is visible — we never hide on uncertainty. Earlier version used a
// pessimistic default that hid widgets if detection was slow/ambiguous,
// which caused real reviews on strikkegenser/Monogram to stay hidden.
(function(){
  function parseCount(w) {
    // Try multiple signals in order of reliability
    // 1) aria-label like "4.5 out of 5 stars from 12 reviews"
    var aria = w.getAttribute('aria-label') || '';
    // Match Klaviyo's aria-label variants: "5 reviews", "5 ratings",
    // "5 anmeldelser", "5 vurderinger". "ratings" is the locale-default
    // shape and was previously missed, causing valid review counts to
    // fall through to null and trigger `no-reviews` on the body.
    var m = aria.match(/(\d+)\s*(reviews?|ratings?|anmeldels|vurdering)/i);
    if (m) return parseInt(m[1], 10);
    // 2) explicit reviews-count element
    var rc = w.querySelector('.kl_reviews__star_rating_widget__reviews-count, [class*="reviews-count"]');
    if (rc) {
      var n = (rc.textContent || '').match(/\d+/);
      if (n) return parseInt(n[0], 10);
    }
    // 3) label text (e.g. "12 anmeldelser" / "12 reviews")
    var label = w.querySelector('.kl_reviews__star_rating_widget__label');
    if (label) {
      var ln = (label.textContent || '').match(/\d+/);
      if (ln) return parseInt(ln[0], 10);
    }
    // 4) any anchor inside the widget
    var a = w.querySelector('a');
    if (a) {
      var an = (a.textContent || '').match(/\d+/);
      if (an) return parseInt(an[0], 10);
    }
    return null; // unknown — don't hide
  }
  var startedAt = Date.now();
  function detect(){
    // Only look at widgets outside the sticky bar / accordion mirrors, since
    // those are clones and don't report independent counts.
    var widgets = Array.prototype.slice.call(
      document.querySelectorAll('.kl_reviews__star_rating_widget')
    ).filter(function(w){
      return !w.closest('.pdp-sticky-bar, [data-clone-review-widget], .accordion__title--review');
    });
    // If no widget has appeared after ~5s, treat the product as having
    // no reviews. Longer grace than before (was 800ms) — slow Klaviyo
    // responses were causing valid products with reviews to be marked
    // `no-reviews` and have the reviews tab hidden.
    if (!widgets.length) {
      if (Date.now() - startedAt > 5000) {
        document.body.classList.add('no-reviews');
      }
      return;
    }
    // A widget is "has reviews" only if we can parse a positive count from it.
    // If the widget renders without a detectable count (empty stars / "Be the
    // first" state), treat as zero.
    var hasAnyReviews = false;
    widgets.forEach(function(w){
      var c = parseCount(w);
      if (c !== null && c > 0) hasAnyReviews = true;
    });
    if (hasAnyReviews) {
      document.body.classList.remove('no-reviews');
      document.body.classList.add('has-reviews');
    } else {
      // 5s grace window — slow Klaviyo responses shouldn't trigger
      // false-negative no-reviews state on products that have reviews.
      if (Date.now() - startedAt > 5000) {
        document.body.classList.add('no-reviews');
        document.body.classList.remove('has-reviews');
      }
    }
  }
  document.body.classList.remove('no-reviews');
  detect();
  document.addEventListener('DOMContentLoaded', detect);
  window.addEventListener('load', detect);
  // Fast polling first 1.5s (catches 800ms grace window commit), then stop.
  var tries = 0;
  var iv = setInterval(function(){
    detect();
    if (++tries >= 10) clearInterval(iv);
  }, 150);
})();
